import React from "react";

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === "object" && value !== null;

const ErrorMessage: React.FC<{ error: unknown }> = ({ error }) => {
    if (isRecord(error) && typeof error.message === "string") {
        return <>{error.message}</>;
    }

    if (typeof error === "string") {
        return <>{error}</>;
    }

    return null;
};

export default ErrorMessage;
